import React from "react";
import { useHistory, useParams } from "react-router-dom";

import { Typography } from "antd";

import { commonTabs } from "containers/Sales/TeamIntelligence/tabs";
import styles from "components/PlatformLayout/components/PlatformPageHeader/PlatformPageHeader.module.less";

const { Title } = Typography;

const TeamPerformanceBreadCrumbs = () => {
  const params = useParams();
  const history = useHistory();

  const activeTab = commonTabs.find((t) => t.key === params.tab);

  const handleBaseNavigate = () => {
    history.push("/team-performance");
  };

  const baseStyle = {
    cursor: "pointer",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  return (
    <>
      <Title className={styles.title} style={baseStyle} onClick={handleBaseNavigate}>
        Team Performance
      </Title>
      {activeTab && (
        <>
          <span className={styles.titleSeparator}>/</span>
          <Title className={styles.titleSecondary}>{activeTab.label}</Title>
        </>
      )}
    </>
  );
};

export default TeamPerformanceBreadCrumbs;
